<template>
<v-app>
    <router-view />
    <Footer/>
</v-app>
</template>

<script>
import Footer from "../components/common/Footer"
export default {
    name: 'Autorizador',
    components: {
        Footer
    },
    beforeMount() {
         let opts = {
          grupoEconomico: this.$store.state.permissions.grupoEconomico,
          modulo_operadora: "autorizador"
        }
        this.$store.dispatch("permissions/getOperadoras", opts)
    },
}
</script>

<style>

</style>